import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss']
})

/**
 * PAges-404 component
 */
export class Page404Component implements OnInit {
  rolUsuario = '';
  tienePermiso2 = false;

  constructor(private user: AuthenticationService) {
    const result = this.user.getUser();
    if (result?.user) {
      this.rolUsuario = result.user.rol?.nombre || '';
    }
    const permisos = result?.permisos ?? [];
    this.tienePermiso2 = permisos.some((p: any) => String(p?.idPermiso) === '2');
  }

  get mostrarTecnico(): boolean {
    return this.rolUsuario === 'Técnico';
  }

  get mostrarDashboard(): boolean {
    return this.rolUsuario !== 'Técnico' && this.tienePermiso2;
  }

  get mostrarOtraRuta(): boolean {
    return this.rolUsuario !== 'Técnico' && !this.tienePermiso2;
  }

  ngOnInit(): void {
    document.body.classList.add('authentication-bg')
    document.body.removeAttribute('data-topbar');
  }

  ngOnDestroy() {
    document.body.classList.remove('authentication-bg')
  }
}
